import {IntlProvider} from "react-intl"
import {Provider as ReduxProvider} from "react-redux"
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider"
import {HashRouter} from "react-router-dom"
import * as React from "react"
import {assert} from "@swarm2/assert"
import {containers, FirebaseConnectRouter} from "@swarm2/core"
import {createReduxStore} from "../redux"
import {theme} from "./Theme"
import Router from "./Router"
import en from "../lang/en"

// mount this separately, so it doesn't mess with the mounting of visual elements
const RootEffects = containers.app.AppRoot(props => null)

// because <HashRouter> insists on exactly one child, but I'd rather not add a <div> to the dom
const WrapRoot = props => props.children
export function AppProvider({store, messages = en} = {}) {
  if (!store) {
    // TODO: should probably require this. Need to define store outside to support hot-reloading.
    // Existing uses all assume it's created here though.
    assert(
      process.env.NODE_ENV !== "production",
      "production app must define a store outside of appprovider",
    )
    store = createReduxStore()
  }
  store = store || createReduxStore()
  return Wrapped => props => (
    <ReduxProvider store={store}>
      <IntlProvider locale="en" messages={messages}>
        <MuiThemeProvider muiTheme={theme}>
          <HashRouter>
            <WrapRoot>
              <FirebaseConnectRouter />
              <RootEffects />
              <Wrapped {...props} />
            </WrapRoot>
          </HashRouter>
        </MuiThemeProvider>
      </IntlProvider>
    </ReduxProvider>
  )
}
export function app(config) {
  return AppProvider(config)(Router)
}



// WEBPACK FOOTER //
// ./src/app/App.js